import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { Panel, Overline, Pill, Icon, PageLoader, EmptyState } from "../../components/ui-kit";

export default function VideosPage() {
  const [videos, setVideos] = useState(null);
  useEffect(() => { api.get("/videos").then(({ data }) => setVideos(data)); }, []);
  if (!videos) return <PageLoader />;

  return (
    <div className="max-w-6xl mx-auto p-4 sm:p-6">
      <div className="mb-7 pt-1"><Overline>Video Library</Overline><h1 className="text-3xl sm:text-4xl font-bold text-mim-navy mt-1 tracking-tight">Watch & Learn</h1></div>
      {videos.length === 0 ? (
        <Panel tint="soft"><EmptyState icon="PlaySquare" title="No videos available yet" subtitle="Your teacher hasn't added videos yet. They'll appear here soon." tone="cyan" /></Panel>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 stagger">
          {videos.map((v) => (
            <Link key={v.id} to={v.topic_id ? `/topic/${v.topic_id}` : "#"}>
              <div className="rounded-3xl overflow-hidden bg-white border border-mim-line shadow-mim hover-lift h-full">
                <div className="relative aspect-video bg-black">
                  <img src={v.thumbnail} alt={v.title} className="w-full h-full object-cover" loading="lazy" />
                  <div className="absolute inset-0 flex items-center justify-center bg-black/25 hover:bg-black/10 transition-colors"><div className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center shadow-lg"><Icon name="Play" className="w-6 h-6 text-mim-navy ml-0.5" /></div></div>
                  <span className="absolute bottom-2 right-2 bg-black/80 text-white text-xs font-semibold px-2 py-0.5 rounded-md">{v.duration}</span>
                </div>
                <div className="p-4">
                  <h4 className="font-semibold text-mim-navy line-clamp-2">{v.title}</h4>
                  <div className="flex items-center gap-2 mt-2"><Pill tone="blue">{v.subject_name}</Pill><span className="text-xs text-mim-muted">{v.views} views</span></div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
